module.exports = {
  wait: 'Palun oodake...',
  login: 'Logi Sisse',
  password: 'Parool',
  select_product: 'Vali Toode',
  enter_code: 'Sisesta SMSi kinnituskood',
  phone_required: 'Telefoni number on kohustuslik väli',
  role_required: 'Valige vähemalt 1 roll',
  name_required: 'Nimi on kohustuslik väli',
  phone_number: 'Telefoni Number',
  phone: 'Mobiili Number',
  email: 'Email',
  product: 'Toode',
  adduser: 'Lisa kasutaja',
  updateuser: 'Uuenda kasutajat',
  back: 'Tagasi',
  clear: 'selge',
  delete: 'Kas soovite kindlasti kustutada?',
  deleteAdmin: 'Seda kontot ei saa kustutada, kuna seda kasutab Zlicki tugitiim. Kui arvate endiselt, et see konto tuleks kustutada, võtke meiega ühendust aadressil support@zlick.it',
  roles: 'rollid',
  accountStatus: 'Konto olek',
  user_email: 'kasutaja_e-post',
  user_name: 'kasutaja_nimi',
  placeholderemail: 'Palun sisesta kasutaja email',
  placeholdername: 'Sisesta kasutajanimi',
  placeholderrole: 'Lisamiseks või värskendamiseks sisestage rollid',
  price: 'Hind',
  new_price: 'Uus Hind',
  product_required: 'Toode on kohustuslik väli',
  payment_type_required: 'Makse tüüp on kohustuslik väli',
  verif_code: 'SMS kinnituskood',
  order_confirmed: 'Tellimus Kinnitatud',
  continue: 'Jätka',
  retry_webhook: 'Kas soovite kindlasti seda veebipõhja uuesti proovida?',
  confirm: 'Kinnitage',
  cancel: 'Tühista',
  start_order: 'Alusta Uut tellimust',
  p_c_sms: 'Ostu kinnitav SMS',
  close: 'Sulge',
  order_info: 'Tellimuse Info',
  pin_required: 'PIN on kohustuslik täita',
  pin_length: 'PIN kood peab olema {length} tähemärki pikk',
  wrong_pin: 'Vale PIN kood. Palun proovi uuesti!',
  max_pin_attempts: 'Kinnituskoodi proovitud 3 korda, rohke katseid ei ole. Palun saada uus SMS',
  something_went_wrong: 'Midagi läks valesti. Palun proovi uuesti',
  send_sms: 'Saada SMS',
  refundNotAllowed: 'Tagasimakse ei ole lubatud',
  refundTooOld: 'Tagasimakset ei saa töödelda, tehing on vanem kui 185 päeva. Palun võtke ühendust Zlick meeskonnaga käsitsi töötlemiseks.',
  alreadyRefunded: 'Tehing on tagastatud',
  refundFailed: 'Tehing ebaõnnestus',
  manualRefund: 'Manuaalne tagastusprotsess',
  createdAt: 'Kuupäev',
  updatedAt: 'uuendatud kell',
  referenceNumber: 'Viitenumber',
  transactionId: 'tehingu ID',
  productName: 'Toote Nimi',
  transactionType: 'Tehingu tüüp',
  period: 'Periood',
  amount: 'Summa',
  user: 'Kasutaja',
  refundReason: 'Maksa tagasi / Selgitus',
  reload: 'Lae uuesti',
  transactions: 'Tehingud',
  orders: 'Tellimused',
  telemarketing: 'Telemarketing',
  addsubscriber: 'Lisage tellija',
  searchPlaceholder: 'Sisesta otsingusõna',
  password_required: 'Parool on kohustuslik',
  password_requirements: 'Parool peab olema vähemalt {length} märki pikk, sisaldama suuri ja väikseid tähti ning vähemalt {numbers} numbrit',
  something_required: '{something} on kohustuslik',
  something_not_valid: '{something} peab olema valiidne',
  temp_password_label: 'Hetkel kehtiv ajutine parool',
  new_password: 'Uus Parool',
  confirm_password: 'Korda uut parooli',
  password_not_match: 'Paroolid ei kattu',
  firstName: 'Eesnimi',
  lastName: 'Perenimi',
  completeRegistration: 'Lõpeta registreerimine',
  subscriber_added: 'Subscriber added',
  expiryDate: 'Kehtivusaeg',
  paymentType: 'Makse tüüp',
  carrier: 'Telekom / Kandja',
  name: 'Lõpeta / Selgitus',
  transaction_id: 'Transaktsiooni ID',
  clientUserId: 'Kliendi kasutajatunnus',
  addSubHead: 'Lisage tellija',
  telemarketingHead: 'Telemarketing',
  ordersHead: 'Tellimused',
  trxHead: 'Tehingud',
  webhooksHead: 'Veebišokid',
  changePasswordHead: 'Muuda salasõna',
  cancelOrderDialog: 'Olete Te kindel, et soovite lõpetada antud tellimuse?',
  unsubscribe: 'Lõpeta tellimus',
  refundReason_required: 'Tagasimakse põhjus on vajalik',
  reset: 'lähtestamine',
  noStatus: 'Staatus puudub',
  oneOffPayment: 'Ühekordne makse',
  ok: 'Okei',
  transactionsHistory: 'Tehingute ajalugu',
  webhook_logs: 'Webhooks',
  refundDialogInfo: 'Please let us know why You are making this refund:',
  refund: 'Refund',
  noResponseFromWebhook: 'No Response received from the webhook, try retrying the webhook.',
  urlWebHook: 'URL',
  eventId: 'Event Id',
  status: 'Status',
  request: 'Request',
  responses: 'Responses',
  requestBody: 'Request Body',
  responseBody: 'Response Body',
  retryAttempts: 'Retry Attempts',
  pincodePlaceholder: 'Sisestage teie meilile saadetud PIN-kood',
  confirmPinCode: 'kinnitage PIN-kood',
  backToLogin: 'Tagasi sisselogimise juurde',
  toolTipTwoFA: 'Selle suvandi lubamine või keelamine juhib kõigi rühma kasutajate kahefaktorilist autentimist. Kui see on lubatud, saadetakse autentimisprotsessi hõlbustamiseks iga kasutaja registreeritud e-posti aadressile PIN-kood',
  pincode_required: 'PinCode on kohustuslik väli',
  pincode_must_be_number: 'Pin-kood peab olema number',
  reports: 'Aruanded'
}



// WEBPACK FOOTER //
// ./src/i18n/strings.ee.js